/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import {
  Segment, Dimmer, Loader, Label, Icon, Pagination, Input, Modal
} from 'semantic-ui-react';
import cx from 'classnames';
import Update from 'immutability-helper';
import { v4 as uuidv4 } from 'uuid';
import $ from 'jquery';
import { withTranslation } from 'react-i18next';
import ContentsHeaderWithResultAll from '../SubHeader/ContentsHeaderWithResultAll';
import Footer from '../Footer/Footer';
import api from '../../api';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';
import expandBtn from '../../images/components/content_file/expand-btn.svg';
import WithRouter from '../Extensions/WithRouter';
import LicenseRow from './LicenseRow';
//import closeBtn from '../../images/components/content_wide_card/closeBtn.png';

class LicenseList extends Component {
  constructor(props) {
    super(props);
    this.modalBody = null;
    this.smallBody = null;
    this.licenseBody = React.createRef();
    this.viewRef = React.createRef();
    this.state = {
      pageSize: this.props.state.user.page_limit,
      currentPage: 1,
      totalPage: '',
      viewMode: this.props.state.user.view_mode,
      licenseList: [],
      error: null,
      isLoading: false,
      isDetailLoading: false,
      isVisible: '',
      hasMore: false,
      activeIndex: [],
      sortValue: '8',
      isSort: false,
      searchKeyword: '',
      startDate: '',
      endDate: '',
      radioValue: 'dttime_any',
      filter: [],
      activePage: '',
      pdfElement: '',
      isRenderListOnly: false,
      isOpenWarnModal: false,
      totalCount: 0,
    };
    this.handleOnScroll = this.handleOnScroll.bind(this);
    this.toggleRow = this.toggleRow.bind(this);
    this.onChangeSorting = this.onChangeSorting.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.clearValue = this.clearValue.bind(this);
    this.clearRadioValue = this.clearRadioValue.bind(this);
    this.clearAllValue = this.clearAllValue.bind(this);
    this.handleFilterData = this.handleFilterData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.handlePaginationChange = this.handlePaginationChange.bind(this);
    this.toggleViewMode = this.toggleViewMode.bind(this);
    this.handleInputActivePageChange = this.handleInputActivePageChange.bind(this);
    this.handleActivePageChange = this.handleActivePageChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.createElementWithCanvas = this.createElementWithCanvas.bind(this);
    this.generatePdfCallback = this.generatePdfCallback.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.props.state.user.initPrecisionLevel();
    window.addEventListener('scroll', this.handleOnScroll);
    const $contentsHeader = $('.contents_header');
    const $tableHeader = $('.table_header');
    const $window = $(window);

    $window.on('scroll.contents_header', () => {
      if ($window.scrollTop() > 140) {
        $contentsHeader.addClass('fixed');
        $tableHeader.addClass('fixed');
      } else {
        $contentsHeader.removeClass('fixed');
        $tableHeader.removeClass('fixed');
      }
    });
    if (this.licenseBody) {
      this.getLicenseList();
    }
    this.renderPopup();
    window.scrollTo(0, 0);
  }

  componentDidUpdate() {
    const { state } = this.props;
    const { viewMode, pageSize } = this.state;

    const userStore = { ...state.user };

    if (viewMode === '' && userStore.view_mode !== '') {
      this.setState({
        viewMode: userStore.view_mode,
      });
    }

    if (pageSize === '' && userStore.page_limit !== '') {
      this.setState({
        pageSize: userStore.page_limit,
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleOnScroll);
  }

  handleActivePageChange(e) {
    const { totalPage, pageSize, activePage } = this.state;
    if (e.key === 'Enter') {
      if (activePage > totalPage) {
        return;
      }
      this.setState({
        licenseList: [],
        activeIndex: [],
        currentPage: activePage,
      }, () => {
        this.getLicenseList(activePage, pageSize);
      });
    }
  }

  handleSearchChange(value) {
    this.setState({
      searchKeyword: value,
    });
  }

  handleInputActivePageChange(e, { value }) {
    const { totalPage } = this.state;
    if (totalPage < value) {
      return;
    }

    this.setState({
      activePage: value,
    });
  }

  handlePageSizeChange(value) {
    this.setState(
      {
        pageSize: value,
        currentPage: 1,
        licenseList: [],
        activeIndex: [],
      },
      () => {
        this.getLicenseList();
      }
    );
  }

  handleOnScroll() {
    const {
      getLicenseList,
      state: {
        error, isLoading, hasMore, viewMode, currentPage
      },
    } = this;

    if (viewMode === 'list') {
      return;
    }

    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const { clientHeight } = document.documentElement;
    if (error || isLoading || !hasMore) {
      return;
    }
    if (scrollTop + clientHeight >= scrollHeight) {
      getLicenseList(currentPage + 1);
    }
  }

  handleChange(value) {
    this.setState(
      {
        searchKeyword: value,
        licenseList: [],
        activeIndex: [],
      },
      () => {
        this.getLicenseList();
      }
    );
  }

  handleFilterData(value) {
    this.setState(
      {
        licenseList: [],
        activeIndex: [],
        startDate: value.uploaded_start,
        endDate: value.uploaded_end,
        filter: value.filter,
        radioValue: value.radio,
      },
      () => {
        this.getLicenseList();
      }
    );
  }

  onChangeSorting = (e) => {
    const { sortValue, isSort } = this.state;
    if (e.currentTarget.dataset.id !== sortValue) {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: false,
          licenseList: [],
          activeIndex: [],
        },
        () => {
          this.getLicenseList();
        }
      );
    } else {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: !isSort,
          licenseList: [],
          activeIndex: [],
        },
        () => {
          this.getLicenseList();
        }
      );
    }
  };

  getLicenseList = (pageNo, limit) => {
    let text;
    let filterData;
    const {
      isSort, sortValue, radioValue, licenseList, pageSize, filter
    } = this.state;
    const { state, t } = this.props;
    const userStore = { ...state.user };
    const page = pageNo || 1;
    let perPage = limit || pageSize;

    if (perPage === '') {
      perPage = userStore.page_limit || localStorage.getItem('page_limit');
    }

    if (this.state.filter.length !== 0) {
      let i = 0;
      for (i; i < filter.length; i++) {
        if (i === 0) {
          filterData = filter[i];
        } else {
          filterData = `${filterData},${filter[i]}`;
        }
      }
      filterData = `${filterData},${radioValue}`;
    } else {
      filterData = `${radioValue}`;
    }
    switch (true) {
    case sortValue === '1':
      if (isSort) {
        text = 'license_name';
      } else {
        text = 'license_name_r';
      }
      break;
    case sortValue === '2':
      if (isSort) {
        text = 'family_r';
      } else {
        text = 'family';
      }
      break;
    case sortValue === '3':
      if (isSort) {
        text = 'component_count_r';
      } else {
        text = 'component_count';
      }
      break;
    case sortValue === '4':
      if (isSort) {
        text = 'component_version_count_r';
      } else {
        text = 'component_version_count';
      }
      break;
    case sortValue === '5':
      if (isSort) {
        text = 'project_count_r';
      } else {
        text = 'project_count';
      }
      break;
    case sortValue === '6':
      if (isSort) {
        text = 'project_version_count_r';
      } else {
        text = 'project_version_count';
      }
      break;
    case sortValue === '7':
      if (isSort) {
        text = 'uploaded_file_count_r';
      } else {
        text = 'uploaded_file_count';
      }
      break;
    case sortValue === '8':
      if (isSort) {
        text = 'last_detected_r';
      } else {
        text = 'last_detected';
      }
      break;
    default:
      text = 'last_detected';
      break;
    }
    this.setState(
      {
        isLoading: true,
      },
      () => {
        api
          .getLicenseList(
            {
              search: this.state.searchKeyword,
              filter: filterData,
              detected_start: this.state.startDate,
              detected_end: this.state.endDate,
              page,
              limit: perPage,
              order: text,
            }
          )
          .then((response) => {
            if (this.state.licenseList.length !== 0 && response.pagination.current === 1) {
              return false;
            }
            const nextLicenseList = response.response.map((item) => {
              return {
                licenseName: item.license_name,
                familyName: item.family,
                componentCount: item.component_count,
                componentVersionCount: item.component_version_count,
                projectCount: item.project_count,
                projectVersionCount: item.project_version_count,
                uploadedFileCount: item.uploaded_file_count,
                lastDetected: item.last_detected,
              };
            });

            this.setState({
              currentPage: response.pagination.current,
              pageSize: response.pagination.per_page,
              totalPage: response.pagination.pages,
              totalCount: response.pagination.count,
              hasMore: response.pagination.next !== null,
              isLoading: false,
              licenseList: [...licenseList, ...nextLicenseList],
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              error: t('modal.error.error_load'),
              isLoading: false,
            });
          });
      }
    );
  };

  getLicenseDetail = (licenseName) => {
    const { t } = this.props;
    const objData = {
      license_name: licenseName,
    };

    this.setState({
      isDetailLoading: true,
      isVisible: licenseName,
    }, () => {
      api
        .getLicenseDetail(objData)
        .then((response) => {
          const { licenseList } = this.state;
          const data = response.response;
          const updatedIndex = licenseList.findIndex((item) => {
            return item.licenseName === licenseName;
          });
          const updatedData = Update(licenseList[updatedIndex], {
            licenseDetail: { $set: data },
          });
          const newData = Update(licenseList, {
            $splice: [[updatedIndex, 1, updatedData]],
          });
          this.setState({
            licenseList: newData,
            isDetailLoading: false,
            isVisible: '',
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            error: t('modal.error.error_load'),
            isDetailLoading: false,
            isVisible: '',
          });
        });
    });
  };

  createElementWithCanvas = () => {
    const { t } = this.props;
    //pdfElement
    const contentElem = document.querySelector('.content');
    if (contentElem) {
      const wrapper = contentElem.closest('.container');
      const clonedObject = wrapper.cloneNode(true);
      const containerEl = clonedObject.closest('.container');
      containerEl.style.paddingTop = 0;

      if (clonedObject) {
        const resultHeaderEl = clonedObject.getElementsByClassName('result_header');
        const resultHeaderInnerEl = clonedObject.getElementsByClassName('result_header_inner');
        const contentsSummaryInnerEl = clonedObject.getElementsByClassName('contents_summary_inner');
        const contentsEl = clonedObject.getElementsByClassName('contents');
        const utilWrapEl = clonedObject.getElementsByClassName('util_wrap');
        const moveTopEl = clonedObject.getElementsByClassName('move_to_top');
        const pageEle = clonedObject.getElementsByClassName('clar_pagination');
        const footerEl = clonedObject.getElementsByClassName('footer');
        const tableEl = clonedObject.getElementsByClassName('wide_card_box');
        const expandTableEl = clonedObject.getElementsByClassName('wide_card_box expand');

        if (expandTableEl.length !== 0) {
          this.modalBody = t('modal.message.clraity_report_main_warn');
          this.smallBody = t('modal.message.clarity_reporty_sub_warn');
          return this.setState({
            isOpenWarnModal: true,
          });
        }

        if (resultHeaderEl.length !== 0) {
          resultHeaderEl[0].style.top = 0;
        }

        if (resultHeaderInnerEl.length !== 0) {
          resultHeaderInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsSummaryInnerEl.length !== 0) {
          contentsSummaryInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsEl.length !== 0) {
          contentsEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (utilWrapEl.length !== 0) {
          while (utilWrapEl.length > 0) {
            utilWrapEl[0].parentNode.removeChild(utilWrapEl[0]);
          }
        }

        if (moveTopEl.length !== 0) {
          while (moveTopEl.length > 0) {
            moveTopEl[0].parentNode.removeChild(moveTopEl[0]);
          }
        }

        if (pageEle.length !== 0) {
          while (pageEle.length > 0) {
            pageEle[0].parentNode.removeChild(pageEle[0]);
          }
        }

        if (footerEl.length !== 0) {
          while (footerEl.length > 0) {
            footerEl[0].parentNode.removeChild(footerEl[0]);
          }
        }

        //wide_card_box wide_card_type_01
        if (tableEl.length > 16) {
          let i = 0;
          for (i; i < tableEl.length; i++) {
            if ((i === 15 && tableEl.length > 16) || (i > 15 && (i - 15) % 18 === 0)) {
              tableEl[i].classList.add('page-break');
            }
          }
        }
      }

      document.body.appendChild(clonedObject);

      this.setState({
        pdfElement: clonedObject,
        isRenderListOnly: true,
      });
    }
  };

  generatePdfCallback = () => {
    const { pdfElement } = this.state;

    document.body.removeChild(pdfElement);
    this.setState({
      pdfElement: '',
      isRenderListOnly: false,
    });
  };

  toggleRow = (index, licenseName) => {
    const { activeIndex } = this.state;
    let newState;

    if (activeIndex.indexOf(index) > -1) {
      newState = activeIndex.filter((i) => {
        return i !== index;
      });
    } else {
      this.getLicenseDetail(licenseName);
      newState = [...activeIndex, index];
    }
    this.setState({
      activeIndex: newState,
    });
  };

  toggleViewMode = (value) => {
    this.setState({
      viewMode: value,
      currentPage: 1,
      searchKeyword: '',
      licenseList: [],
      activeIndex: [],
    }, () => {
      this.getLicenseList();
    });
  };

  handlePaginationChange = (e, { activePage }) => {
    const { pageSize } = this.state;
    this.setState({
      licenseList: [],
      activeIndex: [],
      currentPage: activePage,
      activePage,
    }, () => {
      this.getLicenseList(activePage, pageSize);
    });
  };

  clearValue = (tagValue) => {
    const { filter } = this.state;
    let newState;
    if (filter.indexOf(tagValue) > -1) {
      newState = filter.filter((el) => {
        return el !== tagValue;
      });
    } else {
      newState = [];
    }
    this.setState(
      {
        licenseList: [],
        activeIndex: [],
        filter: newState,
      },
      () => {
        this.getLicenseList();
      }
    );
  };

  clearRadioValue = () => {
    this.setState(
      {
        licenseList: [],
        activeIndex: [],
        startDate: '',
        endDate: '',
        radioValue: 'dttime_any',
      },
      () => {
        this.getLicenseList();
      }
    );
  };

  clearAllValue = () => {
    this.setState(
      {
        licenseList: [],
        activeIndex: [],
        filter: [],
        startDate: '',
        endDate: '',
        radioValue: 'dttime_any',
      },
      () => {
        this.getLicenseList();
      }
    );
  };

  closeModal = () => {
    this.modalBody = null;
    this.smallBody = null;
    this.setState({
      isOpenWarnModal: false,
    });
  };

  clearSearch() {
    this.setState(
      {
        searchKeyword: '',
        licenseList: [],
        activeIndex: [],
      },
      () => {
        this.getLicenseList();
      }
    );
  }

  /*
  renderSortValue() {
    const { sortValue } = this.state;
    if (sortValue) {
      if (sortValue.indexOf('_') !== -1) {
        return <img src={downIcon} alt="" />;
      }
      return <img src={upIcon} alt="" />;
    }
    return '';
  }
*/
  renderValue() {
    const { filter, radioValue } = this.state;
    const { t } = this.props;

    const licenseFilter = filter.filter((item) => {
      return item.indexOf('license') > -1;
    });

    const uploadedDateFilter = radioValue;
    const filterObj = {
      license: licenseFilter,
      datetime: uploadedDateFilter,
    };

    return (
      <div>
        {filterObj.license.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('list.title.license')}</strong>
            </span>
            {filterObj.license.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_pt') > -1 && t('list.title.protective')}
                  {item.indexOf('_pm') > -1 && t('list.title.permissive')}
                  {item.indexOf('_o') > -1 && t('list.title.others')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filterObj.datetime.indexOf('dttime_any') === -1 && (
          <Label.Group>
            <span>
              <strong>{t('project.menu.date')}</strong>
            </span>
            <Label as="a">
              {filterObj.datetime.indexOf('dttime_p24') > -1 && t('contents_header.menu.past_24_hours')}
              {filterObj.datetime.indexOf('dttime_pw') > -1 && t('contents_header.menu.past_week')}
              {filterObj.datetime.indexOf('dttime_pm') > -1 && t('contents_header.menu.past_month')}
              {filterObj.datetime.indexOf('dttime_cr') > -1
                  && `${this.state.startDate}~${this.state.endDate}`}
              <Icon
                name="close"
                onClick={() => {
                  return this.clearRadioValue();
                }}
              />
            </Label>
          </Label.Group>
        )}
        {filter.length !== 0 || radioValue.indexOf('dttime_any') === -1 ? (
          <div
            className="clear_all"
            onClick={() => {
              return this.clearAllValue();
            }}
            onKeyUp={() => {
              return this.clearAllValue();
            }}
          >
            {t('project.menu.clear_all_filters')}
          </div>
        ) : null}
      </div>
    );
  }

  renderPopup() {
    $(document).on('mouseover', '.wide_card_wrap .wide_card_table .tac', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
    $(document).on('mouseover', '.wide_card_wrap .wide_card_table .tal', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  render() {
    const {
      error,
      hasMore,
      isLoading,
      isDetailLoading,
      isVisible,
      licenseList,
      activeIndex,
      isSort,
      sortValue,
      filter,
      radioValue,
      viewMode,
      pageSize,
      currentPage,
      totalPage,
      activePage,
      pdfElement,
      startDate,
      endDate,
      searchKeyword,
      totalCount
    } = this.state;

    const {
      state, location, params, t, navigate
    } = this.props;

    return (
      <div ref={this.licenseBody}>
        <ContentsHeaderWithResultAll
          onChangeSearch={this.handleChange}
          onSubmit={this.handleFilterData}
          clearSearch={this.clearSearch}
          filter={filter}
          radioValue={radioValue}
          viewMode={viewMode}
          pageSize={pageSize}
          handlePageSizeChange={this.handlePageSizeChange}
          toggleViewMode={this.toggleViewMode}
          refElement={pdfElement}
          currentPage={currentPage}
          isRenderListOnly={this.state.isRenderListOnly}
          createElementWithCanvas={this.createElementWithCanvas}
          generatePdfCallback={this.generatePdfCallback}
          handleSearchChange={this.handleSearchChange}
          state={state}
          location={location}
          params={params}
          translate={t}
          startDate={startDate}
          endDate={endDate}
          navigate={navigate}
          searchKeyword={searchKeyword}
          totalCount={totalCount}
        />
        <div className="content">
          {filter.length !== 0 || radioValue.indexOf('dttime_any') === -1 ? (
            <div className="tag_list">{this.renderValue()}</div>
          ) : null}
          <div className="content_projects_List">
            <div className="wide_card_wrap">
              <div className="table_header">
                <div className="table_header_inner">
                  <table className="wide_card_table wide_card_scope">
                    <colgroup>
                      <col style={{ width: '3.9%', maxWidth: '36px' }} />
                      <col style={{ width: '13%', maxWidth: '120px' }} />
                      <col style={{ width: '9.1%', maxWidth: '84px' }} />
                      <col style={{ width: '9%' }} />
                      <col style={{ width: '9%' }} />
                      <col style={{ width: '38.7%' }} />
                      <col style={{ width: '13%' }} />
                      <col style={{ width: '4.3%', maxWidth: '40px' }} />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th className="checkbox_wrap tal">
                          <div className="checkbox" />
                        </th>
                        <th className="tal">
                          <a className="sorting_button" data-id="1" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('list.title.license')}
                            {isSort && sortValue === '1' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '1' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="2" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('list.title.family')}
                            {isSort && sortValue === '2' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '2' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="3" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('list.title.component')}
                            {isSort && sortValue === '3' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '3' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="4" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('list.title.component_version_ellipsis')}
                            {isSort && sortValue === '4' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '4' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="sum_th">
                          <table>
                            <colgroup>
                              <col style={{ width: '33%' }} />
                              <col style={{ width: '33%' }} />
                              <col style={{ width: '33%' }} />
                            </colgroup>
                            <tbody>
                              <tr>
                                <th className="tac">
                                  <a
                                    className="sorting_button"
                                    data-id="5"
                                    onClick={this.onChangeSorting}
                                    onKeyUp={this.onChangeSorting}
                                  >
                                    {t('list.title.project')}
                                    {isSort && sortValue === '5' ? <img src={upIcon} alt="" /> : ''}
                                    {!isSort && sortValue === '5' ? <img src={downIcon} alt="" /> : ''}
                                  </a>
                                </th>
                                <th className="tac">
                                  <a
                                    className="sorting_button"
                                    data-id="6"
                                    onClick={this.onChangeSorting}
                                    onKeyUp={this.onChangeSorting}
                                  >
                                    {t('list.title.project_version')}
                                    {isSort && sortValue === '6' ? <img src={upIcon} alt="" /> : ''}
                                    {!isSort && sortValue === '6' ? <img src={downIcon} alt="" /> : ''}
                                  </a>
                                </th>
                                <th className="tac">
                                  <a
                                    className="sorting_button"
                                    data-id="7"
                                    onClick={this.onChangeSorting}
                                    onKeyUp={this.onChangeSorting}
                                  >
                                    {t('list.title.uploaded_files')}
                                    {isSort && sortValue === '7' ? <img src={upIcon} alt="" /> : ''}
                                    {!isSort && sortValue === '7' ? <img src={downIcon} alt="" /> : ''}
                                  </a>
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="8" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('list.title.last_detected')}
                            {isSort && sortValue === '8' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '8' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th>&nbsp;</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {licenseList.map((item, index) => {
                return (
                  <div
                    className={cx('wide_card_box wide_card_type_03', {
                      expand: activeIndex.indexOf(index) >= 0,
                    })}
                    key={item.licenseName.toString()}
                  >
                    <table className="wide_card_table wide_card_item">
                      <colgroup>
                        <col style={{ width: '3.9%', maxWidth: '36px' }} />
                        <col style={{ width: '13%', maxWidth: '120px' }} />
                        <col style={{ width: '9.1%', maxWidth: '84px' }} />
                        <col style={{ width: '57%' }} />
                        <col style={{ width: '4.3%', maxWidth: '40px' }} />
                      </colgroup>
                      <tbody>
                        <tr
                          className="sum_line"
                          onClick={() => {
                            return this.toggleRow(index, item.licenseName);
                          }}
                        >
                          <td className="checkbox_wrap border-none tal">
                            <div className="checkbox" />
                          </td>
                          <td
                            className="border-none tal"
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              maxWidth: '120px',
                            }}
                          >
                            <strong>{item.licenseName}</strong>
                          </td>
                          <td className="border-none tac">{item.familyName}</td>
                          <td className="tal sum_td" colSpan="4">
                            <table className="wide_card_table wide_card_item">
                              <colgroup>
                                <col style={{ width: '12.9%' }} />
                                <col style={{ width: '12.9%' }} />
                                <col style={{ width: '55.5%' }} />
                                <col style={{ width: '18.6%' }} />
                              </colgroup>
                              <tbody>
                                <tr>
                                  <td className="tac">{item.componentCount}</td>
                                  <td
                                    className="tac"
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {item.componentVersionCount}
                                  </td>
                                  <td className="sum_td tac">
                                    <table className="sub_table">
                                      <colgroup>
                                        <col style={{ width: '33%' }} />
                                        <col style={{ width: '33%' }} />
                                        <col style={{ width: '33%' }} />
                                      </colgroup>
                                      <tbody>
                                        <tr>
                                          <td className="tac">{item.projectCount}</td>
                                          <td className="tac">{item.projectVersionCount}</td>
                                          <td className="tac">{item.uploadedFileCount}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                  <td className="tac">{item.lastDetected}</td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td className="border-none tac">
                            <a
                              className="expand_button"
                            >
                              <img src={expandBtn} alt="" />
                            </a>
                          </td>
                        </tr>
                        {
                          isDetailLoading && isVisible === item.licenseName ? (
                            <tr>
                              <td className="border-none" colSpan="7">
                                <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
                                  <Loader active={isDetailLoading && isVisible === item.licenseName} inline="centered" />
                                </div>
                              </td>
                            </tr>
                          ) : (
                            <tr className="extend_item">
                              <td className="checkbox_wrap border-none tal">&nbsp;</td>
                              <td className="border-none tal">&nbsp;</td>
                              <td className="border-none tac">&nbsp;</td>
                              <td className="tal border-none sum_td" colSpan="4">
                                {
                                  item.licenseDetail
                                    && (
                                      <LicenseRow
                                        childRef={this.viewRef}
                                        rowData={item.licenseDetail}
                                        t={t}
                                        state={state}
                                        location={location}
                                        params={params}
                                      />
                                    )
                                }
                              </td>
                            </tr>
                          )
                        }
                      </tbody>
                    </table>
                    {item.licenseDetail ? (
                      <div className="wide_card_detail">
                        <div className="wide_card_detail_top type_description">
                          <p className="description">{t('list.title.family_detail')}</p>
                          <p className="version_text">{item.licenseDetail.license_family}</p>
                          {/**
                            <p className="foo">
                              Related Licenses
                            </p>
                            <p className="version_text">
                              {item.licenseDetail.score}
                            </p>
                            */}
                        </div>
                        <div className="wide_card_detail_bottom">
                          {/*<a className="card_detail_popup_show" data-type="0" style={{ cursor: 'pointer' }}>More Information</a>*/}
                          {/*<a className="card_detail_popup_show" data-type="1" style={{ cursor: 'pointer' }}>Matched Detail</a>*/}
                        </div>
                      </div>
                    ) : null}
                    {/*
                      item.licenseDetail ? (
                        <div className="card_detail_popup card_detail_popup_1">
                          <div className="popup_box">
                            <h3 className="popup_header">
                              <a className="card_detail_popup_hide">
                                <img src={closeBtn} alt="" />
                              </a>
                            </h3>
                            <div className="popup_content">
                              <Scrollbars renderTrackHorizontal={() => <div />} renderThumbHorizontal={() => <div />}>
                                <div className="type_3 ">
                                  <dl>
                                    <dt>Access Vector</dt>
                                    <dd>{item.licenseDetail.more_info.access_vector}</dd>
                                  </dl>
                                  <div className="line" />
                                  <dl>
                                    <dt>Website</dt>
                                    {
                                    item.licenseDetail.more_info.web_site.length !== 0 ? (
                                        item.licenseDetail.more_info.web_site.map((info, l) => {
                                          return (
                                            <dd key={l}>{info}</dd>
                                          );
                                        })
                                      ) : ('')
                                    }
                                  </dl>
                                  <div className="line" />
                                  <dl>
                                    <dt>Availability Impact</dt>
                                    <dd className="pink">
                                      <em>Components used in this or other projects</em>
                                    </dd>
                                  </dl>
                                  {
                                item.licenseDetail.more_info.vuln_sw.length !== 0 ? (
                                  <table className="table_type_2">
                                    <colgroup>
                                      <col width="50%" />
                                      <col width="50%" />
                                    </colgroup>
                                    {
                                        item.licenseDetail.more_info.vuln_sw.map((vuln, i) => {
                                          return (
                                            <tr key={i}>
                                              <td>{item.licenseDetail.more_info.vuln_sw[i]}</td>
                                              <td>{item.licenseDetail.more_info.vuln_sw[i + 1]}</td>
                                            </tr>
                                          );
                                        })
                                    }
                                  </table>
                                  ) : ('')
                                  }
                              </div>
                          ` </Scrollbars>
                          </div>
                        </div>
                      </div>
                      ) : ('')
                                */}
                  </div>
                );
              })}
              {error && <div className="error_log">{error}</div>}
              {isLoading && (
                <Segment>
                  <Dimmer active inverted>
                    <Loader size="medium" style={{ lineHeight: '15px' }}>{t('list.title.loading')}</Loader>
                  </Dimmer>
                </Segment>
              )}
              {
                viewMode === 'list' && licenseList.length !== 0
                && (
                  <div className="clar_pagination" style={{ marginTop: '10px', textAlign: 'center' }}>
                    <Pagination
                      activePage={currentPage}
                      totalPages={totalPage}
                      onPageChange={this.handlePaginationChange}
                      //size="mini"
                      ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
                      firstItem={currentPage !== 1 ? { content: <Icon name="angle double left" />, icon: true } : null}
                      lastItem={currentPage !== totalPage ? { content: <Icon name="angle double right" />, icon: true } : null}
                      prevItem={currentPage > 1 ? { content: <Icon name="angle left" />, icon: true } : null}
                      nextItem={currentPage < totalPage ? { content: <Icon name="angle right" />, icon: true } : null}
                    />
                    <div className="active_page">
                      <Input
                        type="number"
                        label={t('list.title.active_page')}
                        min={1}
                        value={activePage}
                        onChange={this.handleInputActivePageChange}
                        onKeyPress={this.handleActivePageChange}
                      />
                    </div>
                  </div>
                )
              }
              {!hasMore && <Footer />}
            </div>
          </div>
        </div>
        <Modal open={this.state.isOpenWarnModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{t('modal.title.attention')}</h2>
                <p className="text">{this.modalBody}</p>
                {
                  this.smallBody
                  && <p className="small_text">{this.smallBody}</p>
                }
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(LicenseList))));
